import React, { useState, useEffect, useCallback } from "react";
import { DateIRLToErache, EracheMonths, ParseEracheDateFromText, EracheToDateIRL, GetEracheDateComponents, apiDateToDate } from "../utils/dateConverters";
import DatePicker, { registerLocale } from "react-datepicker";
import fr from "date-fns/locale/fr";
import "react-datepicker/dist/react-datepicker.css";
import styled from "styled-components";
import axios from "axios";
import { Error, Button, Label } from './styles'
import { baseUrl } from "../config";
import CategorySelection from './CategorySelection';
import { groupEventCategoriesFromApi } from "../utils/eventCategories";
import { useParams } from "react-router-dom";

import { TextField, Select, FormControl, MenuItem, InputLabel, RadioGroup, Radio, FormControlLabel } from "@mui/material";

registerLocale("fr", fr);

const CreateEvent = () => {
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [selectedCustomCategories, setSelectedCustomCategories] = useState([]);
  const [computedDate, setComputedDate] = useState("");
  const [date, setDate] = useState(new Date());
  const [name, setName] = useState("");
  const [rpDescription, setRPDescription] = useState("");
  const [hrpDescription, setHRPDescription] = useState("");
  const [links, setLinks] = useState([]);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const [officialCategories, setOfficialCategories] = useState([]);
  const [selectedOfficialStatus, setSelectedOfficialStatus] = useState("");
  const [actorsCategories, setActorsCategories] = useState([]);
  const [selectedActors, setSelectedActors] = useState([]);
  const [rpCategories, setRPCategories] = useState([]);
  const [selectedRPCategories, setSelectedRPCategories] = useState([]);
  const [hrpCategories, setHRPCategories] = useState([]);
  const [selectedHRPCategories, setSelectedHRPCategories] = useState([]);
  const [localizationCategories, setLocalizationCategories] = useState([]);
  const [selectedLocalizationCategories, setSelectedLocalizationCategories] = useState([]);
  const [actorsCommunityCategories, setActorsCommunityCategories] = useState([]);
  const [rpCommunityCategories, setRPCommunityCategories] = useState([]);
  const [hrpCommunityCategories, setHRPCommunityCategories] = useState([]);
  const [localizationCommunityCategories, setLocalizationCommunityCategories] = useState([]);

  const [useEracheInput, setUseEracheInput] = useState(false);
  const [eracheDay, setEracheDay] = useState(1);
  const [eracheMonth, setEracheMonth] = useState(1);
  const [eracheYear, setEracheYear] = useState(0);
  const [eracheFreeText, setEracheFreeText] = useState("");

  const { eventId } = useParams(); // eventId will be undefined if not editing

  const applyCategoryPayload = useCallback((data) => {
    const g = groupEventCategoriesFromApi(data);
    setCategoryOptions(g.customOptions);
    setOfficialCategories(g.officialCategories);
    setActorsCategories(g.actorsCategories);
    setActorsCommunityCategories(g.actorsCommunityCategories);
    setRPCategories(g.rpCategories);
    setRPCommunityCategories(g.rpCommunityCategories);
    setHRPCategories(g.hrpCategories);
    setHRPCommunityCategories(g.hrpCommunityCategories);
    setLocalizationCategories(g.localizationCategories);
    setLocalizationCommunityCategories(g.localizationCommunityCategories);
  }, []);

  const handleEracheFreeTextChange = (text) => {
    const parsed = ParseEracheDateFromText(text);
    if (parsed) {
      setEracheDay(parsed.day);
      setEracheMonth(parsed.month);
      setEracheYear(parsed.year);
    }
  };

  const handleDateChange = (selectedDate) => {
    setDate(selectedDate);
    updateDate(selectedDate);
    const erache = GetEracheDateComponents(selectedDate);
    setEracheDay(erache.day);
    setEracheMonth(erache.month);
    setEracheYear(erache.year);
  };

  useEffect(() => {
    axios.get(baseUrl + "/event-categories")
      .then(res => {
        applyCategoryPayload(res.data);
        if (!eventId) updateDate(new Date());
      })
      .catch(err => {
        setError("Erreur lors de la récupération des catégories: " + err.message);
      });
  }, [eventId, applyCategoryPayload]);

  useEffect(() => {
    if (!eventId) return; // Only fetch if editing
    axios.get(`${baseUrl}/events/${eventId}`, { withCredentials: true })
      .then(res => {
        const event = res.data.data;
        setName(event.name);
        const eventDate = apiDateToDate(event.date);
        if (eventDate) {
          setDate(eventDate);
          setComputedDate(DateIRLToErache(eventDate, true));
          const erache = GetEracheDateComponents(eventDate);
          setEracheDay(erache.day);
          setEracheMonth(erache.month);
          setEracheYear(erache.year);
        }
        setRPDescription(event.rpDescription || "");
        setHRPDescription(event.hrpDescription || "");
        setLinks(Array.isArray(event.links) ? [...event.links] : []);
        const grouped = event.categories.reduce((acc, cat) => {
          if (!acc[cat.metaCategoryName]) {
            acc[cat.metaCategoryName] = [];
          }
          acc[cat.metaCategoryName].push({
            label: cat.name,
            value: cat.id
          });
          return acc;
        }, {});
        const official = grouped["Officiel/non officiel"] || [];
        setSelectedOfficialStatus(official.length > 0 ? official[0].value : "");
        setSelectedActors((grouped["Acteur"] || []).map(cat => cat.value));
        setSelectedRPCategories((grouped["RP"] || []).map(cat => cat.value));
        setSelectedHRPCategories((grouped["HRP"] || []).map(cat => cat.value));
        setSelectedLocalizationCategories((grouped["Localisation"] || []).map(cat => cat.value));
        setSelectedCustomCategories(grouped["Custom"] || []);


      })
      .catch(err => {
        setError("Impossible de charger l'événement pour édition.");
      });
  }, [eventId]);


  const handleEracheDateChange = (newDay, newMonth, newYear) => {
    const day = newDay !== undefined ? newDay : eracheDay;
    const month = newMonth !== undefined ? newMonth : eracheMonth;
    const year = newYear !== undefined ? newYear : eracheYear;
  
    setEracheDay(day);
    setEracheMonth(month);
    setEracheYear(year);
  
    const newDate = EracheToDateIRL(Number(year), Number(month), Number(day));
    if (newDate && !isNaN(newDate.getTime())) {
      setDate(newDate);
      updateDate(newDate);
    }
  };



  const updateDate = (selectedDate) => {
    const conversionResult = DateIRLToErache(selectedDate, true);
    setComputedDate(conversionResult);
  };

  const handleRPDescriptionChange = (e) => {
    setRPDescription(e.target.value);
  };

  const handleHRPDescriptionChange = (e) => {
    setHRPDescription(e.target.value);
  };

  const handleNameChange = (e) => {
    setName(e.target.value);
  };

  const handleCreateCustomCategory = async (inputValue) => {
    try {
      const response = await axios.post(
        baseUrl + "/event-categories",
        { name: inputValue, metaCategoryName: "Custom" },
        { withCredentials: true }
      );
      const newCategory = response.data;
      const res = await axios.get(baseUrl + "/event-categories");
      applyCategoryPayload(res.data);
      setSelectedCustomCategories((prev) => [...prev, { label: newCategory.name, value: newCategory.id }]);
    } catch (err) {
      setError("Erreur lors de la création de la catégorie.");
    }
  };

  const handleCreateCommunityCategory = async (metaCategoryName, inputValue) => {
    try {
      const response = await axios.post(
        baseUrl + "/event-categories",
        { name: inputValue, metaCategoryName },
        { withCredentials: true }
      );
      const newCategory = response.data;
      const res = await axios.get(baseUrl + "/event-categories");
      applyCategoryPayload(res.data);
      const key = {
        Acteur: "actors",
        RP: "rp",
        HRP: "hrp",
        Localisation: "localization",
      }[metaCategoryName];
      if (!key) return;
      const adder = {
        actors: setSelectedActors,
        rp: setSelectedRPCategories,
        hrp: setSelectedHRPCategories,
        localization: setSelectedLocalizationCategories,
      }[key];
      adder((prev) => [...prev, newCategory.id]);
    } catch (err) {
      setError("Erreur lors de la création de la catégorie.");
    }
  };

  const resetCreateForm = () => {
    const now = new Date();
    setName("");
    setRPDescription("");
    setHRPDescription("");
    setLinks([]);
    setSelectedCustomCategories([]);
    setSelectedOfficialStatus("");
    setSelectedActors([]);
    setSelectedRPCategories([]);
    setSelectedHRPCategories([]);
    setSelectedLocalizationCategories([]);
    setUseEracheInput(false);
    setDate(now);
    updateDate(now);
    const erache = GetEracheDateComponents(now);
    setEracheDay(erache.day);
    setEracheMonth(erache.month);
    setEracheYear(erache.year);
    setEracheFreeText("");
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setMessage("");

    if (!name || !date) {
      setError("Le nom et la date sont requis.");
      return;
    }
    if (!selectedOfficialStatus) {
      setError("Veuillez choisir le statut officiel ou non officiel.");
      return;
    }

    const categories = selectedCustomCategories.map(cat => cat.value);
    categories.push(selectedOfficialStatus);

    let dateToSend = date;
    if (useEracheInput) {
      dateToSend = EracheToDateIRL(Number(eracheYear), Number(eracheMonth), Number(eracheDay));
      if (isNaN(dateToSend.getTime())) {
        setError("Date érachienne invalide.");
        return;
      }
    }

    categories.push(...selectedActors, ...selectedRPCategories, ...selectedHRPCategories, ...selectedLocalizationCategories);

    const payload = {
      name,
      date: dateToSend.toISOString().slice(0, 16),
      rpDescription,
      hrpDescription,
      links: links.filter(u => u.trim() !== ""),
      categories: categories,
    };
    try {
      if (eventId) {
        await axios.put(`${baseUrl}/events/${eventId}`, payload, { withCredentials: true });
        setMessage("Événement modifié avec succès !");
      } else {
        await axios.post(
          baseUrl + "/events",
          payload,
          { withCredentials: true }
        );
        setMessage("Événement créé avec succès !");
        resetCreateForm();
      }
    } catch (err) {
      if (err.response && err.response.status === 400) {
        setError("Veuillez remplir tous les champs requis.");
      } else if (err.response && err.response.status === 403) {
        setError(
          "Vous n'êtes pas autorisé à créer un événement. Ouvrez Mon profil pour répondre au quiz et obtenir le rôle contributeur."
        );
      } else {
        setError("Erreur lors de la création de l'événement:", err.error);
      }
    }
  };

  return (
    <Container>
      <h1>{eventId ? "Modifier un événement existant" : "Créer un événement"}</h1>
      <Form onSubmit={handleSubmit}>
        <TextField
          label="Nom de l'évènement"
          required
          size="small"
          value={name}
          onChange={handleNameChange}
        />
        <FormRow>
          <FormCol>
            <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
              <Label style={{ marginBottom: 0, minWidth: 255 }}>Mode de saisie de la date :</Label>
              <RadioGroup
                row
                value={useEracheInput ? "erache" : "irl"}
                sx={{ marginLeft: "4px" }}
                onChange={e => setUseEracheInput(e.target.value === "erache")}
              >
                <FormControlLabel
                  value="irl"
                  control={<Radio size="small" />}
                  label="Date IRL classique"
                  sx={{ "& .MuiFormControlLabel-label": { fontSize: "0.95rem" } }}
                />
                <FormControlLabel
                  value="erache"
                  control={<Radio size="small" />}
                  label="Date érachienne"
                  sx={{ "& .MuiFormControlLabel-label": { fontSize: "0.95rem" } }}
                />
              </RadioGroup>
            </div>
          </FormCol>
        </FormRow>

        {!useEracheInput ? (
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <DatePicker
              showIcon
              selected={date}
              onChange={handleDateChange}
              showTimeSelect
              timeCaption="Heure"
              dateFormat="yyyy-MM-dd HH:mm"
              locale="fr"
              showYearDropdown
              showMonthDropdown
              scrollableYearDropdown
              yearDropdownItemNumber={30}
            />
            {computedDate && (
              <span style={{ color: "#555" }}>
                Date érachienne : {computedDate}
              </span>
            )}
          </div>
        ) : (
          <>
            <InputRow>
              <TextField
                label="Date érachienne (texte libre)"
                value={eracheFreeText}
                onChange={e => {
                  setEracheFreeText(e.target.value);
                  handleEracheFreeTextChange(e.target.value);
                }}
                placeholder="Ex: Le 12 Pampélune de l'an de grâce 3"
                size="small"
                sx={{ minWidth: 400 }}
              />
              <span
                style={{
                  margin: '0 12px',
                  fontWeight: 'bold',
                  fontSize: '24px',
                  alignSelf: 'center',
                  height: '100%',
                  display: 'flex',
                  alignItems: 'center'
                }}
              >
                /
              </span>
              <FormControl size="small" sx={{ minWidth: 100 }}>
                <TextField
                  label="Jour"
                  type="number"
                  inputProps={{ min: 1, max: 64 }}
                  value={eracheDay}
                  onChange={e => handleEracheDateChange(Number(e.target.value), undefined, undefined)}
                  size="small"
                />
              </FormControl>
              <FormControl size="small" sx={{ minWidth: 130 }}>
                <InputLabel id="month-label">Mois</InputLabel>
                <Select
                  labelId="month-label"
                  value={eracheMonth}
                  label="Mois"
                  onChange={e => handleEracheDateChange(undefined, Number(e.target.value), undefined)}
                  size="small"
                >
                  {EracheMonths.map((m, idx) => (
                    <MenuItem key={m} value={idx + 1}>{m}</MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl size="small" sx={{ minWidth: 100 }}>
                <TextField
                  label="Année"
                  type="number"
                  value={eracheYear}
                  onChange={e => handleEracheDateChange(undefined, undefined, Number(e.target.value))}
                  size="small"
                />
              </FormControl>
            </InputRow>
          </>
        )}

        <CategorySelection
          variant="event"
          value={{
            actors: selectedActors,
            rp: selectedRPCategories,
            hrp: selectedHRPCategories,
            localization: selectedLocalizationCategories,
            custom: selectedCustomCategories,
            officialStatus: String(selectedOfficialStatus || ''),
          }}
          onChange={(key, val) => {
            if (key === 'officialStatus') setSelectedOfficialStatus(Number(val));
            else if (key === 'actors') setSelectedActors(val);
            else if (key === 'rp') setSelectedRPCategories(val);
            else if (key === 'hrp') setSelectedHRPCategories(val);
            else if (key === 'localization') setSelectedLocalizationCategories(val);
            else if (key === 'custom') setSelectedCustomCategories(val);
          }}
          groupedCategories={{
            actorsCategories,
            rpCategories,
            hrpCategories,
            localizationCategories,
            actorsCommunityCategories,
            rpCommunityCategories,
            hrpCommunityCategories,
            localizationCommunityCategories,
            customOptions: categoryOptions,
            officialCategories,
          }}
          onCreateCustomCategory={handleCreateCustomCategory}
          onCreateCommunityCategory={handleCreateCommunityCategory}
        />

        <Label>Description RP:</Label>
        <TextField
          value={rpDescription}
          multiline
          onChange={handleRPDescriptionChange}
          rows={4}
          placeholder="Décrivez votre événement ici de façon RP"
        />
        <Label>Description HRP:</Label>
        <TextField
          value={hrpDescription}
          multiline
          onChange={handleHRPDescriptionChange}
          rows={4}
          placeholder="Décrivez votre événement ici de façon HRP"
        />
        <Label>Liens (Wikifield, ou tout autre URL)</Label>
        {links.map((url, i) => (
          <InputRow key={i}>
            <TextField
              type="url"
              placeholder="https://wikifield.fr/wiki/..."
              size="small"
              value={url}
              onChange={(e) => {
                const next = [...links];
                next[i] = e.target.value;
                setLinks(next);
              }}
              fullWidth
            />
            <Button type="button" onClick={() => setLinks(links.filter((_, j) => j !== i))} style={{ flexShrink: 0 }}>
              Retirer
            </Button>
          </InputRow>
        ))}
        <Button type="button" onClick={() => setLinks([...links, ""])} style={{ alignSelf: "flex-start" }}>
          Ajouter un lien
        </Button>
        <Button
          type="submit"
          style={{
            alignSelf: "center",
            width: "min(100%, 240px)",
            justifyContent: "center",
          }}
        >
          {eventId ? "Modifier l'évènement" : "Publier"}
        </Button>
        {message && <Success>{message}</Success>}
        {error && <Error>{error}</Error>}
      </Form>
    </Container>
  );
};

const Container = styled.div`
  max-width: 900px;
  margin: 0 auto;
  padding: 30px;
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;


const Success = styled.div`
  color: green;
  margin-top: 10px;
`;

const FormRow = styled.div`
  display: flex;
  gap: 24px;
  flex-wrap: wrap;
`;

const FormCol = styled.div`
  flex: 1 1 200px;
  min-width: 200px;
`;

const InputRow = styled.div`
  display: flex;
  gap: 10px;
  margin-bottom: 15px;
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 5px;
    width: 100%;
    align-items: stretch;
  }
`;

export default CreateEvent;
